var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 9.54545,
    fill: "#13BD7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2799 7.82271C23.3086 7.17372 22.1667 6.82733 20.9985 6.82733C19.4321 6.82733 17.9298 7.44959 16.8222 8.55722C15.7145 9.66485 15.0923 11.1671 15.0923 12.7335C15.0923 13.9017 15.4387 15.0436 16.0877 16.0149C16.7366 16.9861 17.6591 17.7432 18.7383 18.1902C19.8175 18.6372 21.0051 18.7542 22.1508 18.5263C23.2965 18.2984 24.3489 17.7359 25.1749 16.9099C26.0009 16.0839 26.5634 15.0315 26.7913 13.8858C27.0192 12.7401 26.9022 11.5526 26.4552 10.4733C26.0082 9.39412 25.2511 8.47169 24.2799 7.82271ZM16.4046 5.85837C17.7644 4.94979 19.3631 4.46484 20.9985 4.46484C23.1915 4.46484 25.2947 5.33601 26.8454 6.88669C28.3961 8.43737 29.2673 10.5406 29.2673 12.7335C29.2673 14.3689 28.7823 15.9676 27.8737 17.3274C26.9652 18.6872 25.6737 19.747 24.1628 20.3728C22.6519 20.9987 20.9893 21.1624 19.3854 20.8434C17.7814 20.5243 16.308 19.7368 15.1516 18.5804C13.9952 17.424 13.2077 15.9507 12.8886 14.3467C12.5696 12.7427 12.7333 11.0802 13.3592 9.56925C13.985 8.05834 15.0449 6.76695 16.4046 5.85837ZM30.4527 37.5398H32.8152V31.6335C32.8152 29.4405 31.944 27.3374 30.3933 25.7867C28.8426 24.236 26.7394 23.3648 24.5464 23.3648H17.4589C15.2659 23.3648 13.1627 24.236 11.612 25.7867C10.0614 27.3374 9.19019 29.4405 9.19019 31.6335V37.5398H11.5527V31.6335C11.5527 30.0671 12.1749 28.5648 13.2826 27.4572C14.3902 26.3496 15.8925 25.7273 17.4589 25.7273H24.5464C25.3221 25.7273 26.0901 25.8801 26.8067 26.1769C27.5232 26.4737 28.1743 26.9088 28.7228 27.4572C29.2712 28.0057 29.7063 28.6567 30.0031 29.3733C30.2999 30.0899 30.4527 30.8579 30.4527 31.6335V37.5398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1e478a53487d2da8d159bece887210bf.svg";
export { ForwardRef as ReactComponent };